import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import { WhatsApp } from '@material-ui/icons'
import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { CheckCircleFill, Search, XCircleFill } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'

import { Center } from '../../../components/Center'
import { CustomButton } from '../../../components/CustomButton'
import { CustomInputDate } from '../../../components/CustomInputDate'
import { CustomInputMask } from '../../../components/CustomInputMask'
import { CustomLoadSelect } from '../../../components/CustomLoadSelect'
import { CustomPriceInput } from '../../../components/CustomPriceInput'
import { IconButton } from '../../../components/IconButton'

import apinode from '../../../services/apinode'
import FuncionariosService from '../../../services/database/FuncionariosService'
import ReclamacoesService from '../../../services/database/ReclamacoesService'

import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

import 'react-datepicker/dist/react-datepicker.css'
import { CustomSpinner } from '../../../components/CustomSpinner'

export const FormReclamacao = forwardRef(
  ({ onSubmit, onClose, isRequestLoading, loadingData }, ref) => {
    const [contas, setContas] = useState([])
    const [isLoadingContas, setIsLoadingContas] = useState(true)

    const [funcionarios, setFuncionarios] = useState([])
    const [isLoadingFuncionarios, setIsLoadingFuncionarios] = useState(true)

    const [data, setData] = useState({
      codigo: '',
      data_entrada: new Date(),
      cliente: '',
      cpf: '',
      status: '',
      id_loja: '',
      problema_ocasionado: '',
      motivo_reclamacao: '',
      grupoerro: '',
      subgrupoerro: '',
      agente: '',
      id_ml: '',
      codigo_rastreio: '',
      transportadora: '',
      contato: '',
      data_envio: '',
      data_retorno: '',
      data_solucao: '',
      sac: '',
      email: '',
      taxa_envio: '',
      taxa_retorno: '',
      debito_ml: '',
      credito_ml: '',
      numero_pedido: '',
    })

    const [isLoadingOrder, setIsLoadingOrder] = useState(false)

    function handleChange(e) {
      const { name, value } = e.target

      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }

    function handleDateChange(name, date) {
      setData((prevState) => ({
        ...prevState,
        [name]: new Date(date),
      }))
    }

    async function handleSearchOrder() {
      try {
        setIsLoadingOrder(true)

        const responseData = await ReclamacoesService.getByOrderId(
          data.numero_pedido,
        )

        if (responseData) {
          setData((prevState) => ({
            ...prevState,
            cliente: responseData?.cliente,
            cpf: responseData?.cpf,
            id_loja: responseData?.id_loja,
            contato: responseData?.celular,
          }))
        }
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível localizar o pedido!')
      } finally {
        setIsLoadingOrder(false)
      }
    }

    async function getContas() {
      try {
        setIsLoadingContas(true)

        const response = await apinode.get(
          `/pedido/contas/${localStorage.idconta}`,
        )

        const contasFormatted = response.data.map((conta) => ({
          value: conta.ID_CONTA,
          label: conta.APELIDO,
        }))

        setContas(contasFormatted)
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível listar as contas!')
      } finally {
        setIsLoadingContas(false)
      }
    }

    async function getFuncionarios() {
      try {
        setIsLoadingFuncionarios(true)
        const responseData = await FuncionariosService.getAll()

        const funcionariosFormatted = responseData.map((res) => ({
          value: res.IDFUNCIONARIO,
          label: res.NOMEFUNCIONARIO,
        }))

        setFuncionarios(funcionariosFormatted)
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível listar os agentes')
      } finally {
        setIsLoadingFuncionarios(false)
      }
    }

    useImperativeHandle(
      ref,
      () => ({
        getReclamacao: () => {
          return data
        },
        setReclamacao: (reclamacao) => {
          setData({
            codigo: reclamacao.codigo || '',
            data_entrada: new Date(reclamacao.data_entrada) || '',
            cliente: reclamacao.cliente || '',
            cpf: reclamacao.cpf || '',
            status: reclamacao.status || '',
            id_loja: reclamacao.id_loja || '',
            problema_ocasionado: reclamacao.problema_ocasionado || '',
            motivo_reclamacao: reclamacao.motivo_reclamacao || '',
            grupoerro: reclamacao.grupoerro || '',
            subgrupoerro: reclamacao.subgrupoerro || '',
            agente: reclamacao.agente || '',
            id_ml: reclamacao.id_ml || '',
            codigo_rastreio: reclamacao.codigo_rastreio || '',
            transportadora: reclamacao.transportadora || '',
            contato: reclamacao.contato || '',
            data_envio: new Date(reclamacao.data_envio) || '',
            data_retorno: new Date(reclamacao.data_retorno) || '',
            data_solucao: new Date(reclamacao.data_solucao) || '',
            sac: reclamacao.sac || '',
            email: reclamacao.email || '',
            taxa_envio: reclamacao.taxa_envio || '',
            taxa_retorno: reclamacao.taxa_retorno || '',
            debito_ml: reclamacao.debito_ml || '',
            credito_ml: reclamacao.credito_ml || '',
            numero_pedido: reclamacao.numero_pedido || '',
          })
        },
      }),
      [data],
    )

    useEffect(() => {
      getContas()
      getFuncionarios()
    }, [])

    return (
      <>
        {loadingData ? (
          <div
            style={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 10,
            }}
          >
            <CustomSpinner size={50} />
            <h1
              style={{
                margin: 0,
              }}
            >
              Carregando...
            </h1>
          </div>
        ) : (
          <Form ref={ref}>
            <Row className="mb-3">
              <Col xs={1}>
                <Form.Label>Código</Form.Label>
                <Form.Control
                  name="codigo"
                  value={data.codigo}
                  onChange={handleChange}
                  disabled
                />
              </Col>

              <Col xs={2}>
                <Form.Label>Número do Pedido </Form.Label>

                <Center>
                  <Form.Control
                    name="numero_pedido"
                    value={data.numero_pedido}
                    onChange={handleChange}
                  />

                  <OverlayTrigger overlay={<Tooltip>Pesquisar</Tooltip>}>
                    <IconButton
                      isLoading={isLoadingOrder}
                      onClick={handleSearchOrder}
                    >
                      <Search />
                    </IconButton>
                  </OverlayTrigger>
                </Center>
              </Col>

              <Col xs={2}>
                <Form.Label>Data Entrada</Form.Label>
                <CustomInputDate
                  selected={data.data_entrada}
                  onChange={(date) => handleDateChange('data_entrada', date)}
                />
              </Col>

              <Col>
                <Form.Label>Cliente</Form.Label>
                <Form.Control
                  name="cliente"
                  value={data.cliente}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>CPF/CNPJ</Form.Label>
                <Form.Control
                  name="cpf"
                  value={data.cpf}
                  onChange={handleChange}
                />
              </Col>

              <Col>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="status"
                  value={data.status}
                  onChange={handleChange}
                >
                  <option value="">Não Selecionado</option>
                  <option value="ENTREGUE AO CLIENTE">
                    ENTREGUE AO CLIENTE
                  </option>
                  <option value="ACOMPANHAR ML">ACOMPANHAR ML</option>
                  <option value="DEV.FULL EM ABERTO">DEV.FULL EM ABERTO</option>
                  <option value="ENVIADO">ENVIADO</option>
                  <option value="ATENDIMENTO WAPP">ATENDIMENTO WAPP</option>
                  <option value="INTEGRADO DO ML">INTEGRADO DO ML</option>
                  <option value="COLETA EM ANDAMENTO">
                    COLETA EM ANDAMENTO
                  </option>
                  <option value="COLETA ENCERRADA">COLETA ENCERRADA</option>
                  <option value="INSUCESSO DE ENTREGA">
                    INSUCESSO DE ENTREGA
                  </option>
                  <option value="DEVOLUÇÃO EM ANDAMENTO">
                    DEVOLUÇÃO EM ANDAMENTO
                  </option>
                  <option value="DEVOLUÇÃO ENCERRADA">
                    DEVOLUÇÃO ENCERRADA
                  </option>
                  <option value="COLETA/DEVOLUÇÃO RECEBIDA">
                    COLETA/DEVOLUÇÃO RECEBIDA
                  </option>
                  <option value="DEV.FULL CONCLUIDA">DEV.FULL CONCLUIDA</option>
                  <option value="DEV.FULL ENCERRADA">COLETA ENCERRADA</option>
                </Form.Select>
              </Col>

              <Col>
                <CustomLoadSelect
                  name="id_loja"
                  value={data.id_loja}
                  onChange={handleChange}
                  label="Canal de Venda"
                  options={contas}
                  isLoading={isLoadingContas}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Problema Ocasionado</Form.Label>

                <Form.Control
                  as="textarea"
                  name="problema_ocasionado"
                  value={data.problema_ocasionado}
                  onChange={handleChange}
                  rows="4"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Tipo</Form.Label>
                <Form.Select
                  name="motivo_reclamacao"
                  value={data.motivo_reclamacao}
                  onChange={handleChange}
                >
                  <option value="">Não Selecionado</option>
                  <option value="DEVOLUCAO">DEVOLUÇÃO</option>
                  <option value="MEDIACAO">MEDIAÇÃO</option>
                  <option value="RECLAMACAO">RECLAMAÇÃO</option>
                </Form.Select>
              </Col>

              <Col>
                <Form.Label>Motivo da Solicitação</Form.Label>
                <Form.Select
                  name="grupoerro"
                  value={data.grupoerro}
                  onChange={handleChange}
                >
                  <option value="">Não Selecionado</option>
                  <option value="O comprador disse que se arrependeu da compra">
                    O comprador disse que se arrependeu da compra
                  </option>
                  <option value="O comprador disse que o produto é o que pediu, mas não serve">
                    O comprador disse que o produto é o que pediu, mas não serve
                  </option>
                  <option value="O comprador disse que o produto não é igual ao escolhido">
                    O comprador disse que o produto não é igual ao escolhido
                  </option>
                  <option value="O comprador disse que o produto não é do modelo, cor ou tamanho escolhido">
                    O comprador disse que o produto não é do modelo, cor ou
                    tamanho escolhido
                  </option>
                  <option value="O comprador disse que faltou unidades">
                    O comprador disse que faltou unidades
                  </option>
                  <option value="O comprador disse que faltou peças ou acessórios">
                    O comprador disse que faltou peças ou acessórios
                  </option>
                  <option value="O comprador disse que o produto não funciona">
                    O comprador disse que o produto não funciona
                  </option>
                  <option value="O comprador disse que a embalagem chegou rasgada e o produto está avariado">
                    O comprador disse que a embalagem chegou rasgada e o produto
                    está avariado
                  </option>
                  <option value="O comprador disse que o produto está quebrado ou arranhado">
                    O comprador disse que o produto está quebrado ou arranhado
                  </option>
                  <option value="O comprador disse que o pacote chegou com atraso">
                    O comprador disse que o pacote chegou com atraso
                  </option>
                </Form.Select>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Motivo Reclamação</Form.Label>
                <Form.Select
                  name="subgrupoerro"
                  value={data.subgrupoerro}
                  onChange={handleChange}
                >
                  <option value="">Não Selecionado</option>
                  <option value="Faturamento automático sem SKU">
                    Faturamento automático sem SKU
                  </option>
                  <option value="Venda de carrinho com produto sem SKU">
                    Venda de carrinho com produto sem SKU
                  </option>
                  <option value="Anuncio com SKU errado">
                    Anuncio com SKU errado
                  </option>
                  <option value="Faturamento de modelo ou cor divergente">
                    Faturamento de modelo ou cor divergente
                  </option>
                  <option value="Faturamento com quantidade divergente">
                    Faturamento com quantidade divergente
                  </option>
                  <option value="Anuncio com erro no produto">
                    Anuncio com erro no produto
                  </option>
                  <option value="Separação com contagem errada">
                    Separação com contagem errada
                  </option>
                  <option value="Faltou itens na separação">
                    Faltou itens na separação
                  </option>
                  <option value="Separação de produto divergente">
                    Separação de produto divergente
                  </option>
                  <option value="Troca etiqueta envio">
                    Troca etiqueta envio
                  </option>
                  <option value="Lote com defeito">Lote com defeito</option>
                  <option value="Embalagem não protegeu o produto">
                    Embalagem não protegeu o produto
                  </option>
                  <option value="Faltou peças ou acessório de fábrica">
                    Faltou peças ou acessório de fábrica
                  </option>
                </Form.Select>
              </Col>

              <Col>
                <CustomLoadSelect
                  name="agente"
                  value={data.agente}
                  onChange={handleChange}
                  label="Agente da reclamação"
                  options={funcionarios}
                  isLoading={isLoadingFuncionarios}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Status ML</Form.Label>

                <Form.Control
                  name="id_ml"
                  value={data.id_ml}
                  onChange={handleChange}
                />
              </Col>

              <Col>
                <Form.Label>Rastreio</Form.Label>

                <Form.Control
                  name="codigo_rastreio"
                  value={data.codigo_rastreio}
                  onChange={handleChange}
                />
              </Col>

              <Col>
                <Form.Label>Transportadora</Form.Label>

                <Form.Control
                  name="transportadora"
                  value={data.transportadora}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Telefone de contato</Form.Label>
                <Center>
                  <CustomInputMask
                    name="contato"
                    value={data.contato}
                    onChange={handleChange}
                    mask="(99) 99999-9999"
                  />

                  {data.cliente && data.cpf && data.contato && (
                    <OverlayTrigger
                      overlay={<Tooltip>Mandar Mensagem no WhatsApp</Tooltip>}
                    >
                      <IconButton color="#25D366">
                        <Link
                          to={`https://api.whatsapp.com/send?phone=${data.contato}&text=Olá ${data.cliente}, Sou ${localStorage.username} da empresa ${localStorage.nomeconta}. Estou aqui para te ajudar!`}
                          target="_blank"
                        >
                          <WhatsApp />
                        </Link>
                      </IconButton>
                    </OverlayTrigger>
                  )}
                </Center>
              </Col>

              <Col>
                <Form.Label>Data Envio</Form.Label>

                <CustomInputDate
                  selected={data.data_envio}
                  onChange={(date) => handleDateChange('data_envio', date)}
                />
              </Col>

              <Col>
                <Form.Label>Data Retorno</Form.Label>

                <CustomInputDate
                  selected={data.data_retorno}
                  onChange={(date) => handleDateChange('data_retorno', date)}
                />
              </Col>

              <Col>
                <Form.Label>Data Solução</Form.Label>

                <CustomInputDate
                  selected={data.data_solucao}
                  onChange={(date) => handleDateChange('data_solucao', date)}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col xs={1}>
                <Form.Label>SAC</Form.Label>

                <Form.Control
                  name="sac"
                  maxLength={1}
                  value={data.sac}
                  onChange={handleChange}
                />
              </Col>

              <Col>
                <Form.Label>E-mail</Form.Label>

                <Form.Control
                  type="email"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                />
              </Col>

              <Col xs={2}>
                <Form.Label>Taxa de Envio</Form.Label>

                <CustomPriceInput
                  name="taxa_envio"
                  value={data.taxa_envio}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Taxa de Retorno</Form.Label>

                <CustomPriceInput
                  name="taxa_retorno"
                  value={data.taxa_retorno}
                  onChange={handleChange}
                />
              </Col>

              <Col>
                <Form.Label>Débito ML</Form.Label>

                <CustomPriceInput
                  name="debito_ml"
                  value={data.debito_ml}
                  onChange={handleChange}
                />
              </Col>

              <Col>
                <Form.Label>Crédito ML</Form.Label>

                <CustomPriceInput
                  name="credito_ml"
                  value={data.credito_ml}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <div
              style={{
                display: 'flex',
              }}
            >
              <CustomButton
                isSuccess
                title="Salvar"
                onClick={onSubmit}
                isLoading={isRequestLoading}
                isLoadingText="Salvando..."
              >
                <CheckCircleFill />
              </CustomButton>

              <CustomButton
                onClick={onClose}
                isDelete
                title="Cancelar"
              >
                <XCircleFill />
              </CustomButton>
            </div>
          </Form>
        )}
      </>
    )
  },
)
